//{{-- ------------------------------------------------------------------- --}}
//{{-- Highest level "public" functions                                    --}}
//{{-- ------------------------------------------------------------------- --}}

//{{-- Import global libraries --}}
import DOMPurify from 'dompurify';

//{{-- "global" variables --}}
window.main_winResizeFunctionArr = [];
window.main_pusher = null;
window.main_subscribedChannels = []; //This is to store objects: { channelName, msgType, originalCallback, boundWrapper }
window.sanitize = DOMPurify.sanitize;

//{{-- Highest-level $(function()) --}}
$(function () {
    // Inject a CSS override to prevent Bootstrap from disabling page scroll on modal open.
    $('<style>')
        .text('.modal-open { overflow: auto !important; padding-right: 0 !important; }')
        .appendTo('head');

    alertLogoutReason();
    refreshCSRFToken();
    setDatePickerRegion();

    //{{-- Bind the window resize handler --}}
    $(window).on('resize', function () {
        $.each(main_winResizeFunctionArr, function (index, resizeFunc) {
            window[resizeFunc]();
        });
    });
    $(window).on('beforeunload', function () {
        stopListeningForPusher();
    });

    // Fired when a modal is about to be shown.
    $(document).on('show.bs.modal', '.modal', function() {
        // This logic only applies to the first modal opened, not stacked ones.
        if ($('.modal.show').length > 0) return;

        // Set the modal to scroll with the page instead of being fixed.
        $(this).css({
            'position': 'absolute',
            'top': $(window).scrollTop() + 'px',
            'overflow': 'visible'
        });
    });

    // Fired when a modal has been made visible to the user.
    $(document).on('shown.bs.modal', '.modal', function () {
        // This logic only applies to the first modal opened, not stacked ones.
        if ($('.modal.show').length > 1) return; // Use > 1 here because the current modal is already shown.

        const $modal = $(this);

        // Make the dialog draggable.
        $modal.find('.modal-dialog').draggable({
            handle: ".modal-header"
        });

        // Ensure the backdrop covers the entire document height.
        $modal.css('height', $(document).height() + 'px');
    });

    // Fired when a modal has finished being hidden from the user.
    $(document).on('hidden.bs.modal', '.modal', function() {
        const $modal = $(this);
        const $dialog = $modal.find('.modal-dialog');

        // Reset inline styles to allow Bootstrap to manage the modal again.
        $modal.css({
            'position': '',
            'top': '',
            'height': '',
            'overflow': ''
        });

        // Properly clean up the draggable widget.
        if ($dialog.is('.ui-draggable')) {
            $dialog.draggable('destroy');
        }
    });
});

//{{-- This function must be present for ALL scripts. --}}
//{{-- This inserts a .off() before EVERY .on() event biding with JQuery. --}}
//{{-- This will ensure event handlers are managed consistently, preventing multiple binding when they're loaded dynamically. --}}
//{{-- (obviously, you must use .safeOn() instead of .on() throughout) --}}
$.fn.safeOn = function(eventType, selectorOrHandler, maybeHandler) {
    if (typeof selectorOrHandler === "string") {
        // Delegated event
        return this.off(eventType, selectorOrHandler).on(eventType, selectorOrHandler, maybeHandler);
    } else {
        // Direct event
        let handler = selectorOrHandler;
        return this.off(eventType).on(eventType, handler);
    }
};

//{{-- Get current token using route refresh-csrf and refresh it client-side --}}
//{{-- This must be used in AJAX calls when the server changes the csrf token, like after a successful login or when the session expires --}}
//{{-- Also run it on the initial page load, to make sure the browser cache won't give us an old token --}}
//{{-- With Laravel Mix, we need to bind this function definition to the window object, otherwise it has problems being 'global' --}}
window.refreshCSRFToken = function() { 
    $.get('/refresh-csrf').done(function(data){
        setupAjax(data);
        $('meta[name="csrf-token"]').attr('content', data);
        $('[name="_token"]').val(data); 
    });    
}

//{{-- Function to tell the user why he was logged out --}}
window.alertLogoutReason = function() {
    setTimeout(function() {
        if (isThere(glb_logoutReason)) {
            let reasonMsg = null;
            if (glb_logoutReason === 'timeout') {
                reasonMsg = main_logout_reason_timeout;
            } else if (glb_logoutReason === 'disconnect' ) {
                reasonMsg = main_logout_reason_connection;
            } else if (glb_logoutReason === 'server') {
                reasonMsg = main_logout_reason_server;
            } else {
                reasonMsg = null;
            }
            if (isThere(reasonMsg)) alert(reasonMsg);
        }
    }, 300);
}

function setupAjax(data) {
    $.ajaxSetup({
        headers: { 'X-CSRF-TOKEN': data },
        cache: false,
        statusCode: {
            401: function (jqXHR, textStatus, errorThrown) {
                // Prevent interference if sessionCheck is already handling a logout countdown
                if (typeof sc_countdown_status !== 'undefined' && sc_countdown_status === 'on') {
                    console.warn('AJAX 401 received, but session countdown is active. Letting sessionCheck handle logout.');
                    return;
                }

                // Check if the original request was to the logout URL to prevent loops
                if (this.url === sc_route_logout) { return; }

                if (typeof sc_sessionKill === 'function') {
                    sc_sessionKill('server'); // Use 'server' or 'timeout' or a new specific reason like 'unauthorized_ajax'
                } else {
                    // Fallback if sc_sessionKill is not available
                    window.location.href = sc_route_home+'?logout_reason=unauthorized_ajax'; // Hardcoded fallback
                }
            }
        }
    });
}

//{{-- ================================================ --}}
//{{-- PUSHER STUFF                                     --}}
//{{-- ================================================ --}}

//{{-- Handles all Pusher messages by calling the appropriate callback function for the message type. --}}
window.handlePusherMessages = function(callBackFunction, msgType, data) {
    // Check if the incoming message type (expected in data.message.type) matches the type this listener is interested in
    if (data && data.message && data.message.hasOwnProperty('type')) {
        if (data.message.type == msgType) {
            callBackFunction(data); // Call the original callback with the full data
        }
    }
};

//{{-- Listen for Pusher events on a specific channel and for specific message types --}}
window.listenForPusher = function(channelName, channelCallBack, msgTypeArr) {
    if (notThere(main_pusher) || main_pusher.connection.state === 'disconnected') {
        main_pusher = new Pusher('c6235a2d882d2e2fd9ed', {
            cluster: 'us2',
            authEndpoint: '/broadcasting/auth',
        });
    }

    var pusherChannelObject = main_pusher.channel(channelName);
    if (!pusherChannelObject) {
        pusherChannelObject = main_pusher.subscribe(channelName);
    }
    // Ensure the channel object is valid before proceeding
    if (!pusherChannelObject) {
        console.error("Pusher: Could not subscribe or get channel object for", channelName);
        return;
    }

    msgTypeArr.forEach((msgType) => {
        // Check if this specific logical listener (channelName + msgType + originalCallback) is already registered
        const alreadyExists = main_subscribedChannels.some(sub =>
            sub.channelName === channelName &&
            sub.msgType === msgType &&
            sub.originalCallback === channelCallBack // Compare the actual callback function reference
        );

        if (!alreadyExists) {
            // Create the wrapper function that will be bound
            const boundWrapper = function(data) {
                handlePusherMessages(channelCallBack, msgType, data);
            };

            // Store the subscription details including the wrapper
            main_subscribedChannels.push({
                channelName: channelName,
                msgType: msgType,
                originalCallback: channelCallBack,
                boundWrapper: boundWrapper
            });

            // Bind the wrapper function to the Pusher channel event (Pusher uses the channelName as the event name for channel-specific events)
            pusherChannelObject.bind(channelName, boundWrapper);
        }
    });
};

//{{-- Stop listening for ALL Pusher events, unbind tracked listeners, unsubscribe from channels, and optionally disconnect. --}}
//{{-- This is primarily for global cleanup like 'beforeunload'. --}}
window.stopListeningForPusher = function(channelsToUnsubscribe = [], disconnect = true) {
    if (notThere(main_pusher)) {
        return;
    }

    let channelsToProcessNames = [];

    if (channelsToUnsubscribe.length > 0) {
        // If specific Pusher channel objects were passed, get their names
        channelsToProcessNames = channelsToUnsubscribe.map(chObj => chObj.name).filter(name => isThere(name));
    } else {
        // If no specific channels are provided, assume we are stopping all tracked listeners.
        // Get all unique channel names from our tracking array.
        const uniqueChannelNames = [...new Set(main_subscribedChannels.map(sub => sub.channelName))];
        channelsToProcessNames = uniqueChannelNames;
    }

    // Unbind specific listeners and collect channels to unsubscribe from Pusher
    const channelsActuallyUnsubscribed = new Set();

    main_subscribedChannels.forEach(sub => {
        if (channelsToProcessNames.includes(sub.channelName)) {
            var pusherChannelObject = main_pusher.channel(sub.channelName);
            if (isThere(pusherChannelObject) && typeof sub.boundWrapper === 'function') {
                pusherChannelObject.unbind(sub.channelName, sub.boundWrapper); // Use sub.channelName for event name
                channelsActuallyUnsubscribed.add(sub.channelName);
            }
        }
    });

    // Unsubscribe from Pusher for each channel where listeners were removed
    channelsActuallyUnsubscribed.forEach(channelName => {
        main_pusher.unsubscribe(channelName);
    });

    // Clear our internal tracking array of all listeners that were processed
    if (channelsToUnsubscribe.length === 0) { // Clear all if stopping all
        main_subscribedChannels = [];
    } else { // Otherwise, filter out only those processed
        main_subscribedChannels = main_subscribedChannels.filter(sub => !channelsToProcessNames.includes(sub.channelName));
    }

    // Disconnect from Pusher if requested
    if (disconnect && main_pusher.connection.state === 'connected') {
        // If stopping all (channelsToUnsubscribe was empty) or if all tracked channels are now empty.
        if (channelsToUnsubscribe.length === 0 || main_subscribedChannels.length === 0) {
            main_pusher.disconnect();
        }
    }
};

//{{-- Stop specific Pusher listeners based on channel name, original callback, and optionally message types. --}}
window.stopSpecificPusherListeners = function(channelName, originalCallbackToRemove, msgTypesToRemove = []) {
    if (notThere(main_pusher) || notThere(channelName) || notThere(originalCallbackToRemove)) {
        console.warn("Pusher: stopSpecificPusherListeners called with invalid parameters.", { channelName, originalCallbackToRemove });
        return;
    }

    var pusherChannel = main_pusher.channel(channelName);
    let listenersWereRemoved = false;

    // Filter main_subscribedChannels, keeping only those that DON'T match the criteria for removal.
    main_subscribedChannels = main_subscribedChannels.filter(sub => {
        const isMatch = sub.channelName === channelName &&
                        sub.originalCallback === originalCallbackToRemove &&
                        (msgTypesToRemove.length === 0 || msgTypesToRemove.includes(sub.msgType));

        if (isMatch) {
            if (isThere(pusherChannel) && typeof sub.boundWrapper === 'function') {
                pusherChannel.unbind(sub.channelName, sub.boundWrapper); // Use sub.channelName for event name
                listenersWereRemoved = true;
            }
            return false; // Remove this subscription from the array
        }
        return true; // Keep this subscription
    });

    // If listeners were removed for this channel, check if any other tracked listeners remain for this specific Pusher channel.
    if (listenersWereRemoved && isThere(pusherChannel)) {
        const remainingListenersOnThisChannel = main_subscribedChannels.some(
            sub => sub.channelName === channelName
        );

        if (!remainingListenersOnThisChannel) {
            // No more tracked listeners for this channel in our system, so fully unsubscribe from Pusher for this channel.
            main_pusher.unsubscribe(channelName);
        }
    }
};

//{{-- ================================================ --}}
//{{-- FILE STUFF                                       --}}
//{{-- ================================================ --}}

//{{-- Downloads a file (given a link) without disrupting the websocket connections --}}
//{{-- Use this wherever you would use window.location.href --}}
//{{-- The whole point of this is not to mess with websockets, so it makes no sense to call stopListeningForPusher and ListenForPusher in this function...--}}
//{{-- Downloading the file with window.location closes the websocket connection, so let's avoid that --}}
//{{-- ... by creating an anchor element and clicking it --}}
//{{-- IF THIS IS USED OVER HTTP, DOWNLOAD WILL BE BLOCKED BY CHROME'S DOWNLOAD PROTECTION BS. --}}
window.downloadFilePusherSafe = function(fileUrl, hidemsgdiv = null, showmsgdiv = null) {
    //{{-- If the page is secure, ensure the download URL is also secure for Chrome. --}}
    if (window.location.protocol === 'https:') {
        if (fileUrl.startsWith('http:')) {
            fileUrl = fileUrl.replace('http:', 'https:');
        }
    }

    // Create a temporary anchor element which is more reliable than an iframe
    const link = document.createElement('a');
    link.href = fileUrl;

    // The download attribute suggests a filename to the browser.
    link.setAttribute('download', fileUrl.substring(fileUrl.lastIndexOf('/') + 1));
    link.style.display = 'none'; // Hide the element

    // Append to the document, click, and then remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    //{{-- Handle hiding/showing the divs --}}
    setTimeout(function() {
        if (isThere(hidemsgdiv)) {
            if (hidemsgdiv.includes("Modal")) {
                $(hidemsgdiv).modal('hide');
            } else {
                $(hidemsgdiv).hide();
            }
        }
        if (isThere(showmsgdiv)) $(showmsgdiv).show();
    }, 1500);
}

//{{-- ================================================ --}}
//{{-- DATETIME STUFF                                   --}}
//{{-- ================================================ --}}

//{{-- This takes a full datetime string and returns a properly formatted localized string with date (dt="d") or time (dt="t") or datetime (dt="dt") --}}
//{{-- nosec tells it to drop the seconds in the time --}}
window.formatDateTime = function( datetime, dt, nosec ) {
    var d = dateFromDateTime(datetime);
    var formattedDate = '';
    var formattedTime = '';
    if (dt == "d" || dt =="dt") 
        //{{-- Format date --}}
        formattedDate = $.datepicker.formatDate( "dd-M-yy", d);
    if (dt == "t" || dt =="dt")  {
        //{{-- Format time - For the benefit of IE (which inserts invisible characters in the toLocaleTimeString), we need to use the first replace; the second drops the seconds --}}
        formattedTime = d.toLocaleTimeString().replace(/[^0-9:apmAPM ]/g, '');
        if (nosec) formattedTime = formattedTime.replace(/:\d{1,2}([ ap]|$)/, '$1');
    }
    return (formattedDate + " " + formattedTime).trim();
}  

//{{-- Inserts thousands commas into a number, returns the string; ie, 1234567.89 becomes 1,234,567.89 --}}
//{{-- Supports strings with currency symbols e.g. 'US$ 1234.5'--}}
window.formatNbr = function(nbr){
    nbr = String(nbr);
    // Extract numbers and potential decimal values from the nbr string
    const extractedNumber = parseFloat(nbr.replace(/[^0-9.-]/g, ''));
    let nbrFormatted = nbr;

    if (!isNaN(extractedNumber)) {
        // Check if nbr contains USD or not
        const isUSD = /USD\s|US\$\s/.test(nbr);
        
        // Extract the currency symbol
        const symbolMatch = nbr.match(/[^\d\s,.-]+/);
        const symbol = symbolMatch ? symbolMatch[0] : ''; // Default to empty if not found

        if (isUSD) {
            nbrFormatted = `${symbol} ${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(extractedNumber)}`;
        } else {
            // Return with the extracted currency symbol followed by the formatted value
            const formattedNumber = extractedNumber.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            nbrFormatted = `${symbol} ${formattedNumber}`;
        }
    }

    return nbrFormatted;
}

//{{-- Convert separate date string (in any format) and time (HH:MM:SS) fields to single datetime for sending to MySQL. --}}
//{{-- Returns a string in the format "YYYY-MM-DD HH:MM:SS" --}}
//{{-- Note that these arguments ALREADY refer to the user's timezone and must not be changed. --}}
window.datetimeToMySQL = function(date, time) {
    let tm = " " + time.slice(0,5) + ":00";
    let dt = unLocalizeShortMonth(date);
    let datetime = new Date(dt + tm);           //{{-- This is supposed to create a date in the user's timezone --}}
    return dateToMySQL(datetime);
}

//{{-- Convert JS Date to MySQL-friendly string "YYYY-MM-DD HH:MM:SS" --}}
//{{-- Changes the datetime to adjust it to to the global timezone (which should already be the user's timezone --}}
window.dateToMySQL = function(date) {
    const options = {
        year    : 'numeric',
        month   : '2-digit',
        day     : '2-digit',
        hour    : '2-digit',
        hour12  : false,
        minute  : '2-digit',
        second  : '2-digit',
        timeZone: glb_timezone
    };

    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(date);

    const year   = parts.find(part => part.type === 'year').value;
    const month  = parts.find(part => part.type === 'month').value;
    const day    = parts.find(part => part.type === 'day').value;
    const hour   = parts.find(part => part.type === 'hour').value;
    const minute = parts.find(part => part.type === 'minute').value;
    const second = parts.find(part => part.type === 'second').value;

    const mysqlDateTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    return mysqlDateTime;
}

//{{-- Unlocalize string date with JQuery UI datepicker 3-letter month shortname - supports all datepicker languages --}}
//{{-- Accepts date in both YYYY-MMM-DD and DD-MMM-YYYY formats --}}
//{{-- Returns date in YYYY-MM-DD format --}}
window.unLocalizeShortMonth = function(date) {
    //{{-- Make sure months is string and not already in YYYY-MM-DD format --}}
    if (typeof date === "string" && !(/\d{4}-\d{2}-\d{2}/.test(date))) {
        var day, month, year;
        //{{--  Check if the date is in DD-MMM-YYYY format --}}
        if (/\d{2}-\w{3}-\d{4}/.test(date)) {
            day = date.substring(0,2);
            month = date.substring(3,6).toLowerCase();
            year = date.substring(7);
        }
        //{{-- Check if the date is in YYYY-MMM-DD format --}}
        else if (/\d{4}-\w{3}-\d{2}/.test(date)) {
            year = date.substring(0,4);
            month = date.substring(5,8).toLowerCase();
            day = date.substring(9);
        }
        //{{-- Unlocalize the month --}}
        for (let i=1 ; i<=12; i++) {
            if ($.datepicker.regional["mylocal"].monthNamesShort[i-1].toLowerCase() == month) {
                date = year + "-" + (i<10 ? "0"+i : i) + "-" + day;
                break;
            }
        }
    }
    return date;
}

//{{-- Return a new Date() from a "24-Sep-2019 18:01:02" OR a "2019-09-24 18:01:02" date strings, by using new Date(2019, 09, 01, 18, 00, 00, 000) --}}
//{{-- The ONLY format for 'd' in new Date(d) accepted by all browsers is "2019, 09, 01, 18, 00, 00, 000", so we need to get that from a dd-mmm-yy format --}}
window.dateFromDateTime = function(date) {
    let [newdate, day, month, month2, year, hour, minute, second, milis] = Array(9).fill(null);
    if (typeof date === "string") {
        // First the date
        var dtArr = date.split(" ")[0].split("-");
        if (dtArr[0].length == 4) {
            // we have "2019-09-24" or "2019-Sep-2019"
            day = dtArr[2];
            month = dtArr[1];
            year = dtArr[0];
        } else {
            // we have "24-Sep-2019" or 24-09-2019"
            day = dtArr[0];
            month = dtArr[1];
            year = dtArr[2];
        }        
        if (month.length == 3) {
            for (let i=1 ; i<=12; i++) {
                if ($.datepicker.regional["mylocal"].monthNamesShort[i-1].toLowerCase() == month.toLowerCase()) {
                    month2 =  (i<10 ? "0"+i : i);
                    break;
                }
            }
        } else {
            month2 = month;
        }
        // Then the time
        var tiArr = date.split(" ")[1].split(":");
        hour = tiArr[0];
        minute = (tiArr.length > 1) ? tiArr[1] : "00";
        second = (tiArr.length > 2) ? tiArr[2] : "00";
        milis  = (tiArr.length > 3) ? tiArr[3] : "000";
        newdate = new Date(year, month2-1, day, hour, minute, second, milis);
    }
    return newdate;    
}

//{{-- ================================================ --}}
//{{-- OTHER STUFF                                      --}}
//{{-- ================================================ --}}

//{{-- IE doesn't support array.findIndex --}}
//{{-- So we implement our own - mind this is for two-dimensional arrays only; quick and dirty --}}
//{{-- Alternatively, we could use something like this (used in acbrcanew.blade): $.grep(Object.keys(myArr), function (key, ndx) {} --}}
window.myFindIndex = function (myArr, element, target) {
    index = -1;
    for (let i = 0; i < myArr.length; i++) {
        if (myArr[i][element] === target) {
            index = i;
            break;
        }
    }
    return index;
}

//{{-- Splits a given text into tokens while recording their start and end positions --}}
window.splitWithPositions = function (text) {
    let tokens = [];
    let tokenRegex = /\S+/g;                    //{{-- Regular expression to match sequences of non-whitespace characters --}}
    let match;
    while ((match = tokenRegex.exec(text)) !== null) {
        tokens.push({
            token: match[0],                    //{{-- The matched token (word) --}}
            start: match.index,                 //{{-- Starting index of the token in the text --}}
            end: match.index + match[0].length  //{{-- Ending index of the token in the text --}}
        });
    }
    return tokens;
}

//{{-- Attempt at a generic way to determine if a variable, element, object, primitive or whatever is empty, 0 or false --}}
//{{-- Note that if this function is called, its parameter will always exist, and therefore parm === undefined works; --}} 
//{{-- If you want to check whether a function is called with or without an attribute ( callthis(x) vx callthis() ) then you have to use 'typeof x === "undefined"' in the body of that function --}}
window.notThere = function (p) {
    return (
        typeof p === 'undefined'
        || !p
        || ($.isPlainObject(p) && $.isEmptyObject(p)));
}
window.isThere = function (p) {
    return !notThere(p);
}

//{{-- Original JQuery isNumeric function, deprecated in JQ 3.3 because it "was intended for internal use" and really not used --}}
window.isNumeric = function (obj) {
    return (typeof obj === "number" || typeof obj === "string") &&
        !isNaN(obj - parseFloat(obj)); // parseFloat NaNs numeric-cast false positives (""), but misinterprets leading-number strings, particularly hex literals ("0x...") subtraction forces infinities to NaN
}

//{{-- Implements 3-state sort for columns on JQuery Datatables - as seen in https://stackoverflow.com/questions/43111162/jquery-datatables-can-i-have-3-states-for-sort-asc-desc-and-no-sort --}}
//{{-- Usage: $('#projectsgrid').safeOn('order.dt', function() {sortDatatable("projectsgrid", datatable);}); --}}
window.sortDatatable = function (gridname, datatable) {
    if (datatable.settings().order().length === 1) {
        var order = datatable.settings().order()[0];
        var th = $("#" + gridname + " th:eq(" + order[0] + ")");
        if (th.attr("data-sort-next") === "false") {
            datatable.order([]).draw();
            th.attr("data-sort-next", true);
        } else {
            if (order[1] === "desc") {
                th.attr("data-sort-next", false);
            } else {
                th.attr("data-sort-next", true);
            }
        }
    }
}

//{{-- Table sort function adapted from www.w3schools.com/howto/howto_js_sort_table.asp --}}
//{{-- tableHeader is a JQuery element --}}
//{{-- direction is either 'asc' or 'desc' --}}
window.sortTableByColumnHeader = function (tableHeader, direction) {
    var table = document.getElementById(tableHeader.closest('table').attr('id'));
    var colNbr = tableHeader.index();
    var rows, switching, i, x, y, xval, yval, shouldSwitch;
    switching = true;
    // Make a loop that will continue until no switching has been done:
    while (switching) {
        switching = false;
        // Loop through all table rows (except the first, which contains table headers):
        rows = table.rows;
        for (let i = 1; i < (rows.length - 1); i++) {
            // Start by saying there should be no switching:
            shouldSwitch = false;
            // Get the two elements you want to compare, one from current row and one from the next:
            x = rows[i].getElementsByTagName("TD")[colNbr];
            y = rows[i + 1].getElementsByTagName("TD")[colNbr];
            // Get either string or numeric values:
            xval = x.innerHTML.toLowerCase();
            yval = y.innerHTML.toLowerCase();
            if (isNumeric(xval)) xval = xval * 1;
            if (isNumeric(yval)) yval = yval * 1;
            // Check if the two rows should switch place, based on the direction, asc or desc:
            if (direction == "asc") shouldSwitch = (xval > yval);
            if (direction == "desc") shouldSwitch = (xval < yval);
            // Switch them
            if (shouldSwitch) {
                rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                switching = true;
                break;
            }
        }
    }
}

//{{-- Function to handle numeric input by users who might use commas and periods as either thousands or decimal separators.  --}}
//{{-- e.g. 1,234,567 and 1.234.567 are both integers --}}
//{{-- 1,234,567.89 and 1.234.567,89 are both floats --}}
//{{-- 1,234,56 and 1.234.56 are both floats (first separator is ignored) --}}
//{{-- 1,234, is an integer, 1234 and the dangling separator is ignored --}}
//{{-- Returns the parsed value, or NaN if the element is non-numeric --}}
//{{-- Returns the parsed value, or NaN if the element is non-numeric --}}
window.parseNumericInput = function (jQelement) {
    let value = jQelement.is('input') ? jQelement.val() : jQelement.text();
    value = value.trim();
    let result = NaN;
    if (!/[^0-9.,-]/.test(value)) {                         //{{-- Check for invalid characters --}}
        value = value.replace(/[^\d.,-]/g, '');             //{{-- Replace all non-digit characters except . and , with an empty string --}}
        const hasComma = value.includes(',');
        const hasDot = value.includes('.');
        const lastComma = value.lastIndexOf(',');
        const lastDot = value.lastIndexOf('.');
        const isCommaDecimal = lastComma > lastDot && lastComma < value.length - 1;
        const isDotDecimal = lastDot > lastComma && lastDot < value.length - 1;
        if (hasComma && hasDot) {
            result = parseFloat(isCommaDecimal ? value.replace(/\./g, '').replace(',', '.') : value.replace(/,/g, ''));
        } else if (hasComma && isCommaDecimal) {
            result = parseFloat(value.replace(/\./g, '').replace(',', '.'));
        } else if (hasDot && isDotDecimal) {
            result = parseFloat(value.replace(/,/g, ''));
        } else {
            result = parseInt(value.replace(/[.,]/g, ''), 10);
        }
    }
    return result;
}
